module.exports = __webpack_public_path__ + "img/ic_food_buger.dc97e070.png";